/* Circular · navbar behaviour.
   Lives in assets/ rather than inline in cx-nav.liquid on purpose. An inline <script> in a
   section is parsed by Shopify's Liquid/HTML parser, and this file contains "<" comparisons
   (for(i=0;i<n;i++)) that the parser can mistake for the start of a tag — which produced
   "Attempting to end parsing before HtmlRawNode 'script' was closed". As an asset it is
   parsed by nobody, and it caches across pages.

   Config comes from data attributes on .cxn-wrap: data-cxn-key (the announcement dismissal
   key) and data-cxn-site (the marketing site origin). */
(function(){
var wrap=document.querySelector('[data-cxn-wrap]'); if(!wrap) return;
var nav=wrap.querySelector('[data-cxn]');
var barX=wrap.querySelector('[data-cxn-barx]');
var hasBar=!!wrap.querySelector('[data-cxn-bar]');
var mega=document.querySelector('[data-cxn-mega]');
var burger=wrap.querySelector('[data-cxn-burger]');
var item=wrap.querySelector('[data-cxn-item]');
var toggle=wrap.querySelector('[data-cxn-toggle]');
var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var megaOpen=false,lastFocus=null;
/* bump the "Announcement key" setting whenever the announcement copy changes */
var DKEY=wrap.getAttribute('data-cxn-key')||'cx_ann_dismissed_v2';
var dismissed=false;
try{ dismissed=localStorage.getItem(DKEY)==='1'; }catch(e){}
function setBar(off){ document.documentElement.classList.toggle('cxn-bar-off',!!off); }
if(!hasBar) setBar(true);
else if(dismissed) setBar(true);
if(barX) barX.addEventListener('click',function(){
dismissed=true;
setBar(true);
try{ localStorage.setItem(DKEY,'1'); }catch(e){}
});

/* DEPARTURE 2 · every Shopify page is heroless, so the navbar is solid from the start and
   a spacer always follows it. On Webflow this is the branch taken on heroless pages. */
nav.classList.add('is-solid');
var spacer=document.createElement('div');
spacer.setAttribute('data-cxn-spacer','');
wrap.parentNode.insertBefore(spacer,wrap.nextSibling);

/* current-page highlight. The live script only matched hrefs starting "/", which after the
   port would match nothing — the marketing links are absolute now. Match on pathname. */
var here=location.pathname.replace(/\/+$/,'')||'/';
var origin=location.origin;
Array.prototype.forEach.call(document.querySelectorAll('.cxn-link[href], .cxn-mega li a[href]'),function(a){
var raw=a.getAttribute('href')||'';
var path=raw;
if(raw.indexOf('http')===0){
if(raw.indexOf(origin)!==0) return;      /* an off-site page is never "here" */
try{ path=new URL(raw).pathname; }catch(e){ return; }
}
if(path.charAt(0)!=='/') return;
if((path.replace(/\/+$/,'')||'/')===here) a.classList.add('is-here');
});

/* ---- dropdown previews: a miniature of each feature page's app mockup ----
   [href, title, accent, metric label, value, unit, chip, sparkline points,
    row A [label, value, bar %], row B [label, value, bar %], caption] */
var S=wrap.getAttribute('data-cxn-site')||'';
var PREV=[
['/heart','ECG &amp; Heart Rhythm','#C86A5C','Latest ECG','62','bpm','Sinus rhythm',
[.5,.48,.52,.5,.46,.95,.08,.62,.5,.49,.52,.5,.47,.93,.1,.6,.5,.5],
['HRV','52 ms',64],['Resting heart rate','56 bpm',42],
'Thirty seconds at your finger, checked for atrial fibrillation.'],
['/blood-pressure','Blood pressure','#2F5D62','Latest estimate','116','/74 mmHg','Optimal',
[.42,.5,.46,.58,.52,.6,.55,.48,.44,.5,.47,.43,.4,.45,.42,.38,.41,.39],
['Systolic average','121 mmHg',48],['Days in target','21 of 30',70],
'A direction across weeks, measured against your own calibration.'],
['/sleep','Sleep','#4A5B8C','Last night','86','/100','Restorative',
[.2,.35,.7,.85,.6,.4,.3,.55,.8,.9,.75,.5,.35,.45,.7,.85,.6,.4],
['Deep','1 h 12 m',55],['REM','1 h 44 m',68],
'Stages, breathing and temperature, scored while you sleep through it.'],
['/activity','Activity &amp; Energy','#C99568','Energy today','72','%','Steady',
[.3,.34,.42,.55,.68,.72,.66,.7,.78,.74,.62,.58,.64,.7,.66,.6,.63,.61],
['Steps','9,240',62],['Active minutes','47',52],
'Energy across the day, not only the steps you counted.'],
['/recovery','Recovery','#7EA688','Readiness','78','/100','Ready',
[.45,.5,.42,.38,.5,.62,.7,.66,.6,.68,.75,.72,.65,.7,.78,.74,.7,.76],
['HRV','52 ms',64],['Resting heart rate','56 bpm',42],
'What last night gave back, and what today can ask for.'],
['/vital-alerts','Vital alerts','#C86A5C','Alerts this month','2','reviewed','All clear',
[.5,.5,.49,.51,.5,.5,.78,.5,.5,.51,.5,.49,.5,.5,.5,.72,.5,.5],
['Nights monitored','30 of 30',100],['Median time to alert','4 min',26],
'The ring watches overnight and speaks only when something changes.'],
['/stress','Stress','#7EA688','Balance today','64','/100','Calm',
[.6,.66,.72,.58,.4,.35,.48,.62,.7,.55,.42,.5,.64,.72,.6,.52,.58,.62],
['Calm hours','6 h 20 m',58],['Peaks','3',30],
'Where the load fell today, and where it lifted again.'],
["/womens-health","Women's health",'#A67989','Cycle day','14','of 29','Ovulation window',
[.35,.36,.38,.37,.4,.42,.41,.45,.5,.58,.66,.7,.68,.64,.6,.55,.5,.46],
['Temperature shift','+0.31 °C',55],['Cycle length','29 days',70],
'Temperature and cycle read together, night after night.'],
['/longevity','Longevity','#7EA688','Circular age','31','years','3 below actual',
[.7,.68,.66,.64,.62,.63,.6,.58,.55,.56,.53,.5,.48,.46,.45,.43,.42,.4],
['Cardio fitness','46 VO₂max',66],['Sleep regularity','82 / 100',82],
'A biological age you can actually move.'],
['/alarm-clock','Wake Up','#C99568','Woke at','6:42','am','Light sleep',
[.2,.3,.6,.8,.55,.35,.25,.5,.75,.85,.65,.45,.35,.55,.8,.9,.7,.4],
['Wake window','6:20 – 7:00',60],['Sleep debt','42 min',30],
'A vibration at your lightest moment inside the window you set.'],
['/medication-reminder','Medication reminder','#FF6A1F','Taken on time','94','%','On track',
[.6,.9,.9,.6,.9,.9,.9,.6,.9,.9,.6,.9,.9,.9,.6,.9,.9,.9],
['This week','13 of 14',93],['Streak','26 days',80],
'A tap on the finger, logged whether or not the phone is near.'],
['/live-measurements','Live Measurements','#C86A5C','Live heart rate','68','bpm','Measuring',
[.5,.47,.9,.15,.55,.5,.48,.92,.12,.58,.5,.49,.88,.16,.56,.5,.48,.5],
['Blood oxygen','98 %',98],['Skin temperature','36.6 °C',60],
'Heart rate, oxygen and temperature on demand, in ten seconds.'],
['/guided-breathing','Guided Breathing','#7EA688','Session','4:00','min','Coherence 6 / min',
[.5,.75,.9,.75,.5,.25,.1,.25,.5,.75,.9,.75,.5,.25,.1,.25,.5,.75],
['Sessions this week','5',70],['Average HRV lift','+12 %',55],
'Paced breathing at six a minute, with HRV as the read-out.']
];
var prevBox=wrap.querySelector('[data-cxn-prev]');
if(prevBox){
var cards={},cur=null,curLink=null;
var path=function(p){var d='',i,n=p.length;for(i=0;i<n;i++){d+=(i?'L':'M')+((i/(n-1))*180).toFixed(1)+' '+(30-p[i]*28-1).toFixed(1)}return d};
var row=function(r){return '<div class="cxnp-row"><span>'+r[0]+'</span><b>'+r[1]+'</b></div><div class="cxnp-bar"><i style="width:'+r[2]+'%"></i></div>'};
PREV.forEach(function(f){
var c=document.createElement('div');
c.className='cxnp';
c.style.setProperty('--pc',f[2]);
c.innerHTML='<div class="cxnp-top"><span class="cxnp-ttl">'+f[1]+'</span><span class="cxnp-ring">Ring 78%</span></div>'+
'<div class="cxnp-c"><div class="cxnp-hd"><div><span class="cxnp-ml">'+f[3]+'</span>'+
'<span class="cxnp-v">'+f[4]+'<small>'+f[5]+'</small></span></div><span class="cxnp-chip">'+f[6]+'</span></div>'+
'<svg class="cxnp-spark" viewBox="0 0 180 30" preserveAspectRatio="none" aria-hidden="true"><path d="'+path(f[7])+'"></path></svg></div>'+
'<div class="cxnp-c">'+row(f[8])+row(f[9])+'</div>'+
'<p class="cxnp-ser">'+f[10]+'</p>';
prevBox.appendChild(c);
cards[S+f[0]]=c;
});
var show=function(href,link){
var c=cards[href]; if(!c||c===cur) return;
if(cur) cur.classList.remove('is-on');
if(curLink) curLink.classList.remove('is-lit');
c.classList.add('is-on'); cur=c;
curLink=link||null; if(curLink) curLink.classList.add('is-lit');
};
Array.prototype.forEach.call(item.querySelectorAll('.cxn-dl'),function(a){
var h=a.getAttribute('href');
a.addEventListener('mouseenter',function(){ show(h,a) });
a.addEventListener('focus',function(){ show(h,a) });
});
var firstLink=item.querySelector('.cxn-dl');
if(firstLink) show(firstLink.getAttribute('href'),firstLink);
}

var last=0,tick=false;
function frame(){
tick=false;
var y=window.pageYOffset||document.documentElement.scrollTop;
if(hasBar&&!dismissed) setBar(y>60);
if(!megaOpen&&!item.classList.contains('is-open')){
if(y>220&&y>last+4) wrap.classList.add('is-hid');
else if(y<last-4||y<=220) wrap.classList.remove('is-hid');
}
last=y;
}
window.addEventListener('scroll',function(){ if(!tick){tick=true;requestAnimationFrame(frame)} },{passive:true});
frame();
function closeDrop(){ if(!item) return; item.classList.remove('is-open'); toggle.setAttribute('aria-expanded','false'); }
if(toggle) toggle.addEventListener('click',function(e){
e.stopPropagation();
var open=item.classList.toggle('is-open');
toggle.setAttribute('aria-expanded',open?'true':'false');
});
document.addEventListener('click',function(e){ if(item&&!item.contains(e.target)) closeDrop(); });
function openMega(){
if(!mega||megaOpen) return;
megaOpen=true;
closeDrop();
lastFocus=document.activeElement;
mega.hidden=false;
void mega.offsetWidth;
Array.prototype.forEach.call(mega.querySelectorAll('.cxn-mega__col'),function(c,i){
c.style.transitionDelay=reduce?'0s':(0.05+i*0.05)+'s';
});
mega.classList.add('is-open');
burger.classList.add('is-on');
burger.setAttribute('aria-expanded','true');
burger.setAttribute('aria-label','Close menu');
wrap.classList.remove('is-hid');
nav.classList.remove('is-solid');
document.documentElement.classList.add('cxn-lock');
var first=mega.querySelector('a'); if(first) first.focus({preventScroll:true});
}
function closeMega(){
if(!mega) return;
megaOpen=false;
mega.classList.remove('is-open');
burger.classList.remove('is-on');
burger.setAttribute('aria-expanded','false');
burger.setAttribute('aria-label','Open menu');
document.documentElement.classList.remove('cxn-lock');
nav.classList.add('is-solid');
Array.prototype.forEach.call(mega.querySelectorAll('.cxn-mega__col'),function(c){ c.style.transitionDelay='0s'; });
setTimeout(function(){ if(!megaOpen) mega.hidden=true; },500);
if(lastFocus&&lastFocus.focus) lastFocus.focus({preventScroll:true});
}
if(burger) burger.addEventListener('click',function(){ megaOpen?closeMega():openMega(); });
document.addEventListener('keydown',function(e){
if(e.key!=='Escape') return;
if(megaOpen) closeMega();
else closeDrop();
});
if(mega) mega.addEventListener('click',function(e){ if(e.target.closest('a')) closeMega(); });
})();
